import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/community-portal/community-portal/src/modules/layouts/mdx_layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Process = makeShortcode("Process");
const Box = makeShortcode("Box");
const Button = makeShortcode("Button");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`How to Use GitHub For One-off Changes`}</h1>
    <Process mdxType="Process">
      <Box mdxType="Box">
        <h2>{`Log into Github`}</h2>
        <p>{`Make sure you have a GitHub account and you’re logged in.`}</p>
        <Button to="https://github.com/login" mdxType="Button">Go to Github</Button>
      </Box>
      <Box mdxType="Box">
        <h2>{`Fork the Repo`}</h2>
        <p>{`For simple one off tasks, go to the Github website, and `}<a parentName="p" {...{
            "href": "https://docs.github.com/en/github/getting-started-with-github/fork-a-repo"
          }}>{`fork`}</a>{` the repository (AKA repo) you are making a change to.`}</p>
        <p>{`Forking the repo creates your a version of the site on your GitHub so you can make changes without impacting the original project.`}</p>
        <h3>{`Fork`}</h3>
        <p>{`On the GitHub Website, navigate to the repository you want to change. For example, `}<a parentName="p" {...{
            "href": "https://github.com/makerdao/community"
          }}>{`Community Development's GitHub`}</a>{`.`}</p>
        <p>{`In the top-right corner of the page, click fork
`}<img parentName="p" {...{
            "src": "/images/github-fork-community.png",
            "alt": "click Fork"
          }}></img>{`.`}</p>
        <p>{`That is it. You are now ready to add a file or make changes to any existing file.`}</p>
      </Box>
      <Box mdxType="Box">
        <h2>{`Navigate to File/Folder`}</h2>
        <p>{`Go to your forked version of the repo and then the file you want to edit. For example, the `}<a parentName="p" {...{
            "href": "https://github.com/makerdao/community/blob/master/README.md"
          }}>{`main README file`}</a>{`.`}</p>
      </Box>
      <Box mdxType="Box">
        <h2>{`Edit/Add File`}</h2>
        <h3>{`Edit File`}</h3>
        <p>{`Once in the file, press the pen icon to edit content. This will enter edit mode within Github. Edit mode allows making and proposing new changes without overwriting existing content.`}</p>
        <p><img parentName="p" {...{
            "src": "/images/edit-github-file.png",
            "alt": "Welcome to Comm-dev"
          }}></img></p>
        <h3>{`Add File`}</h3>
        <p>{`Once in the folder that represents proper page placement, press “Create new file”. This will add a new .md file in your own GitHub account. This allows you to propose the addition of your content without publishing it right away.`}</p>
      </Box>
      <Box mdxType="Box">
        <h2>{`Propose File Change/New File`}</h2>
        <p>{`Once file changes are complete, you'll need to commit your changes. To do this scroll to the bottom of the page to where it says "Commit changes," write a short description of your changes, and then click the 'commit changes' button.`}</p>
        <p>{`You will then be prompted to submit a Pull Request (PR). During that process you will be asked for an explanation of changes. This will help any reviewer understand what changes were made, so they can make a decision whether to publish it to the main branch/site. The github GUI makes this easy, but most contributors have a setup that leverages VScode, Atom, or another IDE.`}</p>
        <p><img parentName="p" {...{
            "src": "/images/github-commit-changes.png",
            "alt": "Commit and PR"
          }}></img></p>
      </Box>
      <Box mdxType="Box">
        <h2>{`Stage Changes`}</h2>
        <p>{`Whether uploading a file or making changes to existing work, git will catch all changes made. Depending on the environment (code editor, github's website etc.) initiating a live change is as simple as staging fresh update(s) as commits. This image is in VScode:`}</p>
        <p><img parentName="p" {...{
            "src": "/images/github-simple-commit-vscode.png",
            "alt": "Commit your changes"
          }}></img></p>
      </Box>
      <Box mdxType="Box">
        <h2>{`Create Pull Request`}</h2>
        <p>{`Whether in an IDE, or on Githubs interface, the next step is a pull request (PR). Pull Requests merge any changes (commits) tracked in Git, lumps them together, and suggests a path to merging.`}</p>
        <p><img parentName="p" {...{
            "src": "/images/pull-request-CTA.png",
            "alt": "Open a pull request CTA"
          }}></img></p>
        <p>{`Clicking compare and pull request opens the full pull request page, including checks for merging and fields to exaplin the changes.`}</p>
        <p><img parentName="p" {...{
            "src": "/images/github-create-pull-request.png",
            "alt": "Create Pull request"
          }}></img></p>
      </Box>
      <Box mdxType="Box">
        <h2>{`Review/Merge`}</h2>
        <p>{`There might be feedback/changes on a PR. A reviewer can approve, request changes, or merge the edited file into the repo. Edits can be made with an open PR (often without leaving Github's website) and the PR will update automatically. Once happy, a reviewer will merge your work and it will be live on the site.`}</p>
      </Box>
    </Process>
    {
      /* There was a lot of good GitHub documentation in the Contributor Tools Guide */
    }
    {
      /* I'd hate to lose this content because it's awesome */
    }
    {
      /*
      ## GitHub Overview
      GitHub is a collaborative development platform for open-source software projects. It uses Git, a version control system, to track and log changes to the source code, and display that history front and center.
      MakerDAO uses [GitHub](https://github.com/) for transparent project planning, visible collaboration, and hosting canonical information. It houses all of MakerDAO's documentation and day-to-day work.
      Comm-Dev takes advantage of GitHub's robust graphic user interface (GUI) for Git; opening issues, and managing content files are the bulk of the work. MakerDAO uses a simple Git branching model, where one party manages the master branch and reviews all changes before adding them.
      Check out this short [video](https://www.youtube.com/watch?v=w3jLJU7DT5E) for a brief intro to GitHub.
      :exclamation: **New Users** :exclamation:
      ***Lost and have no idea how GitHub works?***
      *The tutorials in [Getting Started 101](#getting-started-101) below are a great place to start. They cover many of GitHub's functions used for Comm-Dev. Set aside some time to go through them.*
      Experienced users can skip ahead to [Community GitHub Overview](#community-github-overview).
      ### Getting Started 101
      1. Create an account on [GitHub](https://github.com/).
      1. Go through the comprehensive, interactive tutorials on [GitHub Lab](https://lab.github.com).
         - Set aside a few hours to complete the tutorials.
      1. Click [Find Your First Course](https://lab.github.com/login/github).
         - Follow prompts to install GitHub Learning Lab to personal repositories.
      1. Go through the introductory learning paths.
         - [Introduction to GitHub](https://lab.github.com/githubtraining/introduction-to-github)
         - [First Day on GitHub](https://lab.github.com/githubtraining/paths/first-day-on-github)
         - [First Week on GitHub](https://lab.github.com/githubtraining/paths/first-week-on-github)
      ***Pro Tip:** Consider installing [GitHub Desktop](https://desktop.github.com/). Most GitHub functions are available online, but some actions (e.g., uploading images) are more straightforward with GitHub Desktop.*
      ### Community GitHub Overview
      The [MakerDAO Community Repository](https://github.com/makerdao/community) is the collection of documents and resources relating to initiatives from the Community Development group at MakerDAO.
      #### Project Tracking
      - **[Issues](https://github.com/makerdao/community/issues)**
       - Issues contain short, actionable descriptions of tasks.
      - **[Labels](https://github.com/makerdao/community/labels)**
       - Labels loosely define a document to a subgroup. They typically autofill when assigning an issue (e.g., languages or bounties or hackathons).
      - **[Project Board](https://github.com/makerdao/community/projects)**
       - This Board reflects the development stages based on the current workflow.
       - Project Boards use a [Kanban layout](https://en.wikipedia.org/wiki/Kanban_board) to move issues through the columns as they progress.
         - **Icebox:** Issues that are not active for longer than 60 days.
         - **Backlog:** Issues that are blocked or not currently active.
         - **In Progress:** Issues that someone is already tackling.
         - **Ready for Review:** Issues that need to be reviewed or merged.
         - **Done:** Issues automatically move here when the issue is closed, or the PR is merged.
      - **[Epics](https://github.com/makerdao/community#workspaces/community-development-5d2475bd23b522535e2def1d/board?filterLogic=any&repos=166580993)**
       - Epics map to a larger task by nesting multiple issues.
       - For users that don't have Zenhub, Comm-Dev writes "Epic" on one main issue, and includes relevant links.
       - Epics are more visible with Zenhub.
         - **Optional:** Download the [Zenhub](https://chrome.google.com/webstore/detail/zenhub-for-github/ogcgkffhplmphkaahpmffcafajaocjbd) extension.
      #### Best Practices
      ***Pro Tip:** Practice in a test environment first to prevent merging issues down the road. Fork the Maker Community repository (repo) or clone it to a local machine.*
      - Discuss efforts, blockers, and problems in [#community-development](https://chat.makerdao.com/channel/community-development).
      - Ensure repositories are up to date.
      - Make a practice branch for edits and approvals.
       - Fetch the most recent changes.
       - Branch the main repo to create PRs.
      - Create a new issue or find an existing issue.
       - Include links and dependencies in the issue description.
       - Close completed issues manually to mark them as done.
         - It will move within the project board automatically.
      - Commit early and commit often.
       - Submit changes before large merges.
       - Make sure commits are explicit in their changes.
      - Link Pull Requests to existing issues.
       - If unsure of which issue, ask in the [#community-development](https://chat.makerdao.com/channel/community-development) channel.
      - Pull Requests often go through several phases of review before a merge.
       - An Approver may request changes if a submission does not adhere to guidelines or if it needs general revision.
       - When reviewing or addressing change requests, indicate which issues are resolved and update them in the PR thread, either issue by issue, or in one summary comment.
      ### Tips and Visual Guides
      Click the links in this section for short animated examples of key GitHub actions useful for Comm-Dev work. Alternatively, scroll through this [GIF gallery](https://imgur.com/a/eeO7OJM) to quickly see all the expedient demos below in one place.
      - Clone a repository.
       - **Example:** [Cloning a GitHub Repository](https://imgur.com/GjX6cf9)
       - Make sure to have the [repository's URL](repository-url.png)
      - Sync the Comm-Dev repo when it's already on the machine with the Fetch Origin Master button.
         - In the command line, this is called: `$ git fetch`.
       - **Example:** [Fetch Origin Master](https://imgur.com/VREFUKV)
      - Use [GitHub Desktop](https://desktop.github.com/) to simplify uploading images.
      - Create distinct branches to later merge changes into the master.
      - Make branch names short.
       - **Example:** [Upload image locally and create branch name](https://imgur.com/WJ460E8)
      - Rename any incorrectly named files.
         - Make sure filenames on GitHub include dashes instead of spaces.
             - GitHub and GitBooks cannot manage links to files with strange characters (e.g., spaces).
             - See the [naming files](#naming-files-and-versions) section above.
       - **Example:** [Rename a file and pushing it to a local branch](https://imgur.com/EXwsHzA)
      - GitHub desktop opens Pull Requests in the GitHub web GUI.
       - **Example:** [Opening a PR with GitHub Desktop](https://imgur.com/iRYNBC4)
       - **Note:** In the above example, Git tracked all file uploads, compiled each local change (commit) into one PR, and [merged the Pull Request](https://imgur.com/FFIo7nB).
      - Add a file on GitHub’s GUI by opening another Pull Request.
       - Pull Requests merge any changes tracked in Git, similar to file uploads.
       - **Example:** [Add a file with GitHub](https://imgur.com/D3025qz)
      - Comm-Dev uses issues to track work.
       - **Example:** [Opening an Issue](https://imgur.com/MGW0mMJ)
      - Link Pull Requests to the open issue if resolving the issue requires uploading a file.
       - **Example:** [Uploading a file and closing an issue](https://imgur.com/Kl5LtmQ)
      - Consider this screenshot example of a [Pull Request](github-fixing-a-commit.png) on the Comm-Dev repo with multiple annotations, commits, and requests for changes.
         - Key points are labeled:
             1. Multiple commits.
             2. Connect Pull Request to the issue.
             3. The approver requests changes.
             4. The change request asks to fix relative pathing.
             **Note:** Correctly defining relative paths to files within a repo is a common problem.
                 - Depending on where in the repo the file lives, a relative path may involve:
                     - **Full Stops:** `.`
                     - **Slashes:** `/`
                 - For files in the same folder:
                     - Write the file name or use a full stop with a slash`./`.
                     - **Example:** `file-name.md`
                     - **Example:** `./file-name.md`
                 - To navigate to a file one folder up:
                     - Use two full stops with a slash `../`
                     - **Example:** `../contributing/file-one-folder-up.md`
             5. Final comments.
      - If changes are correct, comment on the request and "resolve" the comments.
      - After addressing all change requests, comment on the PR to notify the Approver that it’s time to merge.
      ### Other Helpful Resources
      - Check out [Getting Started](https://help.github.com/en/github/getting-started-with-github) on GitHub Help.
       - See [Writing on GitHub](https://help.github.com/en/categories/writing-on-github) for writing and formatting tips.
      - Check out these recommended introductory videos:
       - [Git & GitHub Crash Course For Beginners](https://youtu.be/SWYqp7iY_Tc)
       - [Git Tutorials by Corey Schafer](https://www.youtube.com/playlist?list=PL-osiE80TeTuRUfjRe54Eea17-YfnOOAx)
      - Check out these other introductory guides:
       - [Git-The Simple Guide](https://rogerdudler.github.io/git-guide/)
       - [Think like a Git](http://think-like-a-git.net/)
      #### Cheat Sheets
      - [Git Cheat Sheet by GitHub](https://education.github.com/git-cheat-sheet-education.pdf)
      - [A Dead Simple GitSheet](https://gitsheet.wtf/)
      - [Git-Tower](https://www.git-tower.com/blog/git-cheat-sheet/)
      - [Interactive Cheat Sheet by NDP](https://ndpsoftware.com/git-cheatsheet.html#loc=workspace;)
      #### Visual Guides
      - [Git Workflow](http://justinhileman.info/article/git-pretty/git-pretty.png)
      - [Visualizing Git](http://onlywei.github.io/explain-git-with-d3/#)
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      